import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEntry12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoveEntry12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M4.522 5.096a.45.45 0 0 1-.45.45H1.164a.45.45 0 0 1 0-.9h2.908a.45.45 0 0 1 .45.45M4.442 6.9a.45.45 0 0 1-.449.45H2.015a.45.45 0 0 1 0-.9h1.978a.45.45 0 0 1 .45.45m6.392-.85a2.775 2.775 0 1 1-5.55 0 2.775 2.775 0 0 1 5.55 0m-.9 0a1.876 1.876 0 1 0-3.751.003 1.876 1.876 0 0 0 3.752-.002"
            />
        </svg>
    );
}
export default memo(IconMoveEntry12);
